import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { StateContextProvider } from "./context";
import { ChainId, ThirdwebProvider } from "@thirdweb-dev/react";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



// const activeChainId: number = ChainId.Mantle;
root.render(
  <React.StrictMode>
    <ThirdwebProvider >
      <BrowserRouter>
        <StateContextProvider>
          <App />
        </StateContextProvider>
      </BrowserRouter>
    </ThirdwebProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
